export const customerDetailsCardData = {
  policyDetails: [
    { heading: "03", subheading: "Policies" },
    { heading: "02", subheading: "Active" },
    { heading: "01", subheading: "Expired" },
    { heading: "00", subheading: "Pending Renewal" },
  ],
  claimDetails: [
    { heading: "01", subheading: "Claims" },
    { heading: "01", subheading: "Open" },
    { heading: "00", subheading: "Closed" },
  ],
  contactDetails: [
    { image: "phoneIcon", text: "(+1) - 3216540987" },
    { image: "mailIcon", text: "john.smith@sims.com" },
  ],
  interactionDetail: {
    text: " 12 Sep ‘24",
  },
};
